import ReactDOM from "react-dom/client"
import { QueryClientProvider } from "react-query"

import * as Sentry from "@sentry/react"
import { browserTracingIntegration, replayIntegration } from "@sentry/react"
import { RecoilRoot } from "recoil"
import RecoilNexus from "recoil-nexus"
import "slick-carousel/slick/slick-theme.css"
import "slick-carousel/slick/slick.css"

import queryClient from "@fuse/recoil/queryClient.ts"

import { isProd } from "@fuse/utils/DeviceDection.ts"

import "@fuse/styles/app-base.css"

import App from "./App.tsx"
import "./index.css"

// Enable Sentry only for production
if (isProd()) {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN_URL,
    integrations: [browserTracingIntegration(), replayIntegration()],
    tracesSampleRate: 1.0,
    sendDefaultPii: true,
    replaysSessionSampleRate: 0.1, // 10% of sessions for replay
    replaysOnErrorSampleRate: 1.0, // 100% of sessions with errors
    beforeSend(event, hint) {
      const error = hint?.originalException

      // Ignore non-error promise rejections
      if (error === null || error === undefined) return null

      return event
    },
  })
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <RecoilRoot>
    <RecoilNexus />
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </RecoilRoot>,
)
